import { configureApiClient, getApiClient } from '@/api_services/apiClient';
import { logger } from '@/utils/logger';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';

/**
 * AuthInitializer configures the API client with Auth0 token management
 * and ensures authenticated users are created in the backend database.
 */
const AuthInitializer: React.FC = () => {
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();

  useEffect(() => {
    async function initializeUser() {
      if (!isAuthenticated || isLoading) return;

      try {
        // Configure API client with Auth0 token fetcher
        // This allows the request interceptor to fetch fresh tokens dynamically
        configureApiClient(getAccessTokenSilently);

        // Create user in database if they don't exist (idempotent operation)
        // The request interceptor will automatically inject the token
        const client = getApiClient();
        await client.post('/users/create', {});

        logger.debug('User initialized in database');
      } catch (error) {
        logger.error('Failed to initialize user in database:', error);
      }
    }

    initializeUser();
  }, [isAuthenticated, isLoading, getAccessTokenSilently]);

  // This component doesn't render anything
  return null;
};

export default AuthInitializer;
